<ul class="breadcrumb">
    <li>
      <a [routerLink]="['/']">Home</a>
    </li>
    <li>Branch</li>
  </ul>
  <section class="card">
    <div class="card-header">
      <span class="cat__core__title">
        <strong>Branch</strong>
      </span>
      <span style="float:right">
        <button class="btn btn-sm btn-primary mb-2" type="button" (click)="removeId()">
          <i class="fa fa-plus"></i>&nbsp;Add Branch</button>
      </span>
    </div>
  
    <div class="card-block datatable-card-block">
      <div class="row">
        <div class="col-lg-12">
          <div class="table-responsive">
            <table id="committeeTable" datatable [dtOptions]="dtOptions2"  [dtTrigger]="dtTrigger" class="row-border hover"
              class="table table-hover compact cell-border nowrap " style="cursor: pointer;">
              <thead>
                <tr>
                  <th>Branch Name </th>
                  <th>Branch Id</th>
                  <th>Email Id</th>
                  <th>Escalation 1</th>
                  <th>Escalation 2</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let branch of responseBranch; let count=index" style="line-height: 25px;"
                  class="highligh-Committee">
                  <td tabindex="1">{{branch.branchName}}</td>
                  <td tabindex="1">{{branch.branchId}}</td>
                  <td tabindex="1">{{branch.emailId}}</td>
                  <td tabindex="1">{{branch.escalation_1 || 'N/A'}}</td>
                  <td tabindex="1">{{branch.escalation_2 || 'N/A'}}</td>
                  <td style='white-space: nowrap'>
                    <button type="button" class="btn btn-sm btn-primary" (click)="onEdit(branch)">
                      <i class="fa fa-edit"></i>
                    </button>
                    &nbsp;
                    <button type="button" class="btn btn-sm btn-danger" (click)="onDeleteBranch(branch._id)">
                      <i class="fas fa-trash"></i>
                    </button>
  
                  </td>
                </tr>
              </tbody>
            </table>
  
            <div class="modal fade show" id="branchModel" tabindex="-1" role="dialog" data-backdrop="static"
              data-keyboard="false" aria-labelledby="" aria-hidden="true">
              <div class="modal-dialog" role="document">
  
                <div class="well">
                  <div class="modal-content">
                    <div class="modal-header">
                      <h5 class="modal-title" id="myModalLabel">
                        <i class="fa fa-plus"></i>&nbsp;Branch Setup
                      </h5>
                      <button aria-label="Close" class="close" data-dismiss="modal" type="button" (click)="restForm()">
                        <i class="fa fa-times"></i>
                      </button>
                    </div>
  
                    <div class="modal-body" [formGroup]="branchForm">
                      <div class="row">
                        <div class="col-md-4">
                          <label class="form-control-label" for="l0">Branch Name</label>
                          <span style="color: red;">*</span>
                        </div>
                        <div class="col-md-8">
                          <div class="form-group">
                            <input id="branchName" type="text" name="branchName" maxlength="100" (change)="onChange('branchName', $event)"
                              formControlName="branchName" class="form-control" style="padding:6px;" />
                            <div
                              *ngIf="(branchForm.controls['branchName'].hasError('required') || branchForm.controls['branchName'].hasError('whitespace')) && branchForm.controls['branchName'].touched  "
                              class="form-control-error-custom">
                              Branch Name is required
                            </div>
                            <div *ngIf="errorMessage?.branchName" class="form-control-error-custom">
                              {{errorMessage?.branchName}}
                            </div>
                          </div>
                        </div>
  
                        <div class="col-md-4">
                          <label class="form-control-label">Branch Id
                            <span style="color: red;">*</span>
                          </label>
                        </div>
                        <div class="col-md-8">
                          <div class="form-group">
                            <input id="branchId" maxlength="25" type="text" name="branchId" formControlName="branchId" (change)="onChange('branchId', $event)"
                              class="form-control" style="padding:6px;">
                            <div
                              *ngIf="(branchForm.controls['branchId'].hasError('required') || branchForm.controls['branchId'].hasError('whitespace')) && branchForm.controls['branchId'].touched "
                              class="form-control-error-custom">
                              Branch ID is required.
                            </div>
                            <div *ngIf="errorMessage?.branchId" class="form-control-error-custom">
                              {{errorMessage?.branchId}}
                            </div>
                          </div>
                        </div>
  
                        <div class="col-md-4">
                          <label class="form-control-label">Email Id
                          </label>
                        </div>
                        <div class="col-md-8">
                          <div class="form-group">
                            <input id="emailId" type="text" name="emailId" formControlName='emailId' class="form-control"
                              style="padding:6px;">
                            <div
                              *ngIf="(branchForm.controls['emailId'].hasError('pattern') || branchForm.controls['emailId'].hasError('pattern')) && branchForm.controls['emailId'].touched "
                              class="form-control-error-custom">
                              Please Enter correct Email.
                            </div>
                          </div>
                        </div>
  
                        <div class="col-md-4">
                          <label class="form-control-label">Escalation 1
                          </label>
                        </div>
                        <div class="col-md-8">
                          <div class="form-group">
                            <input id="escalation_1" type="text" name="escalation_1" formControlName='escalation_1'
                              class="form-control" style="padding:6px;">
                            <div
                              *ngIf="(branchForm.controls['escalation_1'].hasError('pattern') &&  branchForm.controls['escalation_1'].hasError('pattern')&& branchForm.controls['escalation_1'].touched )"
                              class="form-control-error-custom">
                              Please Enter correct Escalation 1
                            </div>
                          </div>
                        </div>
  
  
                        <div class="col-md-4">
                          <label class="form-control-label">Escalation 2
                          </label>
                        </div>
                        <div class="col-md-8">
                          <div class="form-group">
                            <input id="escalation_2" type="text" name="escalation_2" formControlName='escalation_2'
                              class="form-control" style="padding:6px;">
                            <div
                              *ngIf="(branchForm.controls['escalation_2'].hasError('pattern') || branchForm.controls['escalation_2'].hasError('pattern')) && branchForm.controls['escalation_2'].touched "
                              class="form-control-error-custom">
                              Please Enter correct Escalation 2
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="modal-footer">
                      <button id="btnsaveBranch" type="submit" class="btn btn-sm btn-primary"
                        [disabled]="!branchForm.valid" (click)="onSave()">
                        <i class="fa fa-save"></i>&nbsp;Save
                      </button>
                      <button type="button" class="btn btn-sm" data-dismiss="modal" (click)="restForm()">
                        <i class="fa fa-times"></i>&nbsp;Close</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
  
            <div class="modal fade" id="messagePopUp" tabindex="-1" role="dialog" data-backdrop="static"
              data-keyboard="false" aria-labelledby="" aria-hidden="true" style="top: 50px;">
              <div class="modal-dialog" role="document">
                <div class="modal-content">
                  <div id="alertTitle" class="modal-header"
                    style="font-size: 20px; font-weight: bold; padding: 5px 15px;">
                    Title!
                  </div>
                  <div class="modal-body" style="padding: 10px 15px;">
                    <div id="alertMessage" style="font-size: 16px;">
                      Message..
                    </div>
                  </div>
                </div>
              </div>
            </div>
  
            <div class="modal fade show" id="confirmation" tabindex="-1" role="dialog" data-backdrop="static"
              data-keyboard="false" aria-labelledby="" aria-hidden="true" style="top: 50px;">
              <div class="modal-dialog" role="document">
                <div class="modal-content">
                  <div class="modal-header">
                    <h5 class="modal-title" id="myModalLabelForDelete">
                      <i class="fa fa-question-circle-o mr-2"></i>Confirm
                    </h5>
                    <button aria-label="Close" class="close" data-dismiss="modal" type="button">
                      <i class="fa fa-times"></i>
                    </button>
                  </div>
                  <div class="modal-body">
                    <div class="row">
                      <div class="col-sm-12">
                        Are you sure you want to delete this Branch?
                      </div>
                    </div>
                  </div>
                  <div class="modal-footer">
                    <button type="button" class="btn btn-sm btn-danger" (click)="deleteBranch()">
                      <i class="fa fa-check"></i>&nbsp;Yes
                    </button>
                    <button type="button" class="btn btn-sm btn-primary" data-dismiss="modal">
                      <i class="fa fa-times"></i>&nbsp;No
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <app-alert></app-alert>
  </section>